<template>
  <i-input ref="input" :clearable="true" v-on="$listeners" />
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: ''
      }
    },

    watch: {
      value: {
        handler: function (e) {
          this.replace(e);
        },
        immediate: true
      }
    },

    methods: {
      replace(e) {
        this.$nextTick(() => {
          let value = '';

          // eslint-disable-next-line no-useless-escape
          const rule = new RegExp(/^[\*#0-9]+$/);

          if (rule.test(e)) {
            value = e;
          } else {
            value = e.slice(0, -1);
          }

          this.$refs.input.setCurrentValue(value);

          if (this.value !== value) {
            this.$emit('input', value);
          }
        });
      }
    }
  };
</script>
